export let Balance = (() => {

	let fetchData = 1;

	const button = document.getElementById('toggle_balance');
	const dropdown = document.getElementById('player_balance');
	const loader = document.getElementById('balanceLoader');

	const toggleDropdown = () => {
		button.classList.toggle('open');
		if (fetchData) {
			getBalance()
				.then((data) => {
					if (data) {
						if (data.hasOwnProperty('balance') && data.hasOwnProperty('bonus_balance') && data.hasOwnProperty('play_through_balance') && data.hasOwnProperty('currency_symbol') && data.hasOwnProperty('comp_point')) {
							const formatter = new Intl.NumberFormat('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
							});
							document.getElementById('real_balance').innerHTML = data.currency_symbol + formatter.format(data.balance);
							document.getElementById('bonus_balance').innerHTML = data.currency_symbol + formatter.format(data.bonus_balance);
							document.getElementById('playthrough_balance').innerHTML = data.currency_symbol + formatter.format(data.play_through_balance);
							document.getElementById('comps_balance').innerHTML = data.comp_point;
						}
						toggleLoader();
					}
				})
				.then(() => {
					updateWithdrawalLimits();
				})
                .then(() => {
                    updatePendingDeposits();
                })
		} else {
			toggleLoader();
		}

		fetchData = !fetchData;
		return true;
	}

	const toggleLoader = () => {
		loader.classList.toggle('hide');
	}

	const getBalance = async () => {
		const data = await fetch(URL_API('getBalance', 'user'));
		return await data.json();
	}

	const getWithdrawnSum = async () => {
		const data = await fetch(URL_API('getWithdrawalLimit', 'user'));
		return await data.json();
	}

	const updateWithdrawalLimits = () => {
		getWithdrawnSum()
			.then((withdrawn) => {
				if (withdrawn) {
					let wwlimit = document.getElementById('wwlimit');
					let dwlimit = document.getElementById('dwlimit');
					let weeklyLimit = parseInt(wwlimit.dataset.weeklylimit);
					let dailyLimit = parseInt(dwlimit.dataset.dailylimit);
					const currencysymbol = wwlimit.dataset.currencysymbol;

					if (!withdrawn) {
						wwlimit.innerHTML = weeklyLimit > 0 ? `${currencysymbol}${new Intl.NumberFormat('en-US').format(weeklyLimit)}` : `CUSTOM`;
					} else {
						if (withdrawn.hasOwnProperty('sum') && withdrawn.hasOwnProperty('sum_today')) {
							let calculatedWeeklyLimit = weeklyLimit - parseInt(withdrawn.sum);
							calculatedWeeklyLimit = calculatedWeeklyLimit < 0 ? 0 : calculatedWeeklyLimit;
							wwlimit.innerHTML = weeklyLimit > 0 // 0 (no limit) is for custom deals
								? `${currencysymbol}${new Intl.NumberFormat('en-US').format(calculatedWeeklyLimit)}`
								: `CUSTOM`;

							let reachedDailyLimit = parseInt(withdrawn.sum_today); // one withdrawal per day
							dwlimit.innerHTML = dailyLimit > 0 // 0 (no limit) is for custom deals
								? (reachedDailyLimit ? `Reached limit` : `${currencysymbol}${new Intl.NumberFormat('en-US').format(dailyLimit)}`)
								: `CUSTOM`;

						}
					}

				}
			})
	}

    const updatePendingDeposits = () => {
        const pending_deposits = document.querySelector('#toggle_balance .dropdown .widget_pending_deposits');
        if (!pending_deposits) return false;
        pending_deposits.style.display = 'flex';
        pending_deposits.querySelector('.pending').innerHTML = `Checking ...`
        fetch(URL_API('getPendingDeposits', 'user'))
            .then((deps) => deps.json())
            .then((pending_deps) => {
                if (pending_deps.error) {
                    pending_deposits.style.display = 'none'
                    return false;
                }
                if (pending_deps.res.length === 0) {
                    pending_deposits.style.display = 'none'
                    return false;
                } else {
                    let pending_deps_total = 0;
                    pending_deps_total += Object.keys(pending_deps.res).reduce(function(arr, key) {
                        return parseFloat(pending_deps.res[key].amount);
                    }, []);
                    pending_deposits.querySelector('.pending').innerHTML = `$${pending_deps_total}`
                    pending_deposits.style.display = 'flex'
                }
            })
    }

	return {
		button, dropdown, loader, toggleDropdown
	}

})();
